import type { MetricType } from '@repo/api-codegen';
import { useApiListTeamsV2 } from '@repo/api-codegen/v2';
import { useIntegrationSupport } from '../../api';
import { AddMonitorStore } from './store';
import { AddMonitorStoreContext } from './useAddMonitorStoreContext';

export interface AddMonitorStoreProviderProps {
	children: React.ReactNode;
	initialTable?: string;
	initialIntegration?: string;
	initialMetricType?: MetricType;
	initialSearchTerm?: string;
}

export function AddMonitorStoreProvider({
	children,
	initialIntegration,
	initialTable,
	initialMetricType,
	initialSearchTerm = '',
}: AddMonitorStoreProviderProps) {
	const { data: integrationSupport } = useIntegrationSupport();
	const { data: teams } = useApiListTeamsV2({
		queryParams: {
			only_joined: true,
		},
	});
	return (
		<AddMonitorStoreContext.Provider
			value={
				new AddMonitorStore(
					initialTable,
					initialIntegration,
					initialMetricType,
					initialSearchTerm,
					integrationSupport,
					teams
				)
			}
		>
			{children}
		</AddMonitorStoreContext.Provider>
	);
}
